var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { "margin-top": "15px" } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticStyle: { width: "100%" },
                    attrs: {
                      id: "analyticsTable",
                      data: _vm.rows,
                      border: "",
                      fit: false,
                      stripe: "",
                      "max-height": 800,
                      "show-summary": false,
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "Attorney",
                        "min-width": "180",
                        "column-key": "Originating Attorney",
                        prop: "Originating Attorney",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Total Leads",
                        "min-width": "180",
                        "column-key": "Total Leads",
                        prop: "Total Leads",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "SBB",
                        "min-width": "180",
                        "column-key": "SBB",
                        prop: "SBB",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "SBB Rate",
                        "min-width": "180",
                        "column-key": "SBB Rate",
                        prop: "SBB Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "No Show",
                        "min-width": "180",
                        "column-key": "NS",
                        prop: "NS",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "No Show Rate",
                        "min-width": "180",
                        "column-key": "NS Rate",
                        prop: "NS Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Retainer Sent",
                        "min-width": "180",
                        "column-key": "Retainer Sent",
                        prop: "Retainer Sent",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Retainer Sent Rate",
                        "min-width": "180",
                        "column-key": "Retainer Sent Rate",
                        prop: "Retainer Sent Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Not Retained",
                        "min-width": "180",
                        "column-key": "Not Retained",
                        prop: "Not Retained",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Not Retained Rate",
                        "min-width": "180",
                        "column-key": "Not Retained Rate",
                        prop: "Not Retained Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "DNQ",
                        "min-width": "180",
                        "column-key": "DNQ",
                        prop: "DNQ",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "DNQ Rate",
                        "min-width": "180",
                        "column-key": "DNQ Rate",
                        prop: "DNQ Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Filed",
                        "min-width": "180",
                        "column-key": "Filed",
                        prop: "Filed",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Filed Rate",
                        "min-width": "180",
                        "column-key": "Filed Rate",
                        prop: "Filed Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Closed",
                        "min-width": "180",
                        "column-key": "Closed",
                        prop: "Closed",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Closed Rate",
                        "min-width": "180",
                        "column-key": "Closed Rate",
                        prop: "Closed Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "UBB",
                        "min-width": "180",
                        "column-key": "UBB",
                        prop: "UBB",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "UBB Rate",
                        "min-width": "180",
                        "column-key": "UBB Rate",
                        prop: "UBB Rate",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Retained",
                        "min-width": "180",
                        "column-key": "Retained",
                        prop: "Retained",
                        "header-align": "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Retain Rate",
                        "min-width": "180",
                        "column-key": "Retain Rate",
                        prop: "Retain Rate",
                        "header-align": "center",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }